export const LabelGroups = {
  LABELS: "labels",
  PROJECT_TYPES: "project-types",
  UNLISTED: "unlisted",
}